export default "__VITE_ASSET__NqanBJrB__"